import React from "react";
import { Table, Space, Button } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  EyeOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import PermissionRender from "../../../components/PermissionRender";

export const ZoneTable = ({
  zones,
  loading,
  editingZone,
  isEditing,
  onView,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  onShowDetails, // Add this prop
}) => {
  const columns = [
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Préfixe",
      dataIndex: "prefix",
      key: "prefix",
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Nombre de zones",
      dataIndex: "sectionCount",
      key: "sectionCount",
      render: (_, record) => record.sections.length,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {editingZone?.id === record.id ? (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={onSave}>
                Enregistrer les modifications
              </Button>
              <Button danger icon={<CloseOutlined />} onClick={onCancel}>
                Annuler
              </Button>
            </>
          ) : (
            <>
              <Button
                icon={<EyeOutlined />}
                onClick={() => onView(record)}
                disabled={isEditing}
              >
                {/* Afficher */}
              </Button>
              <PermissionRender requiredPermission={["zone", "update"]}>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => onEdit(record)}
                  disabled={isEditing}
                >
                  {/* Modifier */}
                </Button>
              </PermissionRender>
              <PermissionRender requiredPermission={["zone", "view"]}>
                <NavLink
                  to={`/zones/${record.id}/sections`}
                  disabled={isEditing}
                >
                  <Button icon={<ApartmentOutlined />}>{/* Sections */}</Button>
                </NavLink>
              </PermissionRender>
              {/* <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDelete(record.id)}
                disabled={isEditing}
              >
                Supprimer
              </Button> */}
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={zones}
      rowKey="id"
      loading={loading}
      // pagination={{ pageSize: 5 }}
      size="small"
    />
  );
};
